import { FilterItem } from "components/Filters/types";
import {
  SearchQueryOrderDirection,
  SearchSuggestionsField,
  SearchSuggestionsFieldType,
} from "types/generated";

import { IntegrationType } from "./types";

const INTEGRATIONS_STORAGE_KEY = "integrations";
export const FILTER_TYPE = `${INTEGRATIONS_STORAGE_KEY}-filters`;
export const FILTERS_ORDER_SETTINGS_KEY = `${INTEGRATIONS_STORAGE_KEY}-filters-order`;

export const INTEGRATIONS_FILTERS_DICTIONARY: Record<IntegrationType, string> = {
  source_code: "Source code",
  cloud: "Cloud",
  communication: "Communication",
  observability: "Observability",
  idp: "Internal Developer Platforms",
  api: "APIs",
  ai: "AI",
};

export const FILTER_VARIABLES = {
  filterType: FILTER_TYPE,
  initialSortDirection: SearchQueryOrderDirection.Asc,
  initialSortOption: "",
};

export const INTEGRATION_FILTER_TYPE: SearchSuggestionsField = {
  filterable: true,
  name: "type",
  orderable: false,
  possibleValuesEnum: {
    counts: new Array(IntegrationType.length).fill(0),
    directCounts: new Array(IntegrationType.length).fill(0),
    values: IntegrationType,
  },
  possibleValuesBoolean: null,
  possibleValuesString: null,
  possibleValuesHierarchy: null,
  possibleValuesTime: null,
  type: SearchSuggestionsFieldType.Enum,
};
export const INTEGRATION_FILTER_CONFIGURED: SearchSuggestionsField = {
  filterable: true,
  name: "configured",
  orderable: false,
  possibleValuesEnum: null,
  possibleValuesBoolean: {
    counts: new Array(2).fill(0),
    values: [true, false],
    directCounts: null,
  },
  possibleValuesString: null,
  possibleValuesHierarchy: null,
  possibleValuesTime: null,
  type: SearchSuggestionsFieldType.Boolean,
};

export const FILTER_KEY_CATEGORIES = "categories";
export const FILTER_KEY_CONFIGURED = "configured";

export const INTEGRATIONS_FILTERS_ONLY_CATEGORIES = [
  {
    key: FILTER_KEY_CATEGORIES,
    filterName: FILTER_KEY_CATEGORIES,
    type: SearchSuggestionsFieldType.Enum,
  },
];

export const INTEGRATIONS_FILTERS: FilterItem[] = [
  {
    key: FILTER_KEY_CATEGORIES,
    filterName: FILTER_KEY_CATEGORIES,
    type: SearchSuggestionsFieldType.Enum,
  },
  {
    key: FILTER_KEY_CONFIGURED,
    filterName: FILTER_KEY_CONFIGURED,
    type: SearchSuggestionsFieldType.Boolean,
  },
];
